import { Avatar, Clickable, Col, GroupAvatar, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Menu } from './';

const ChatHeader = ({ chat, removeSelection }) => {
  const [showMenu, setShowMenu] = useState(false),
    currentUser = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    navigate = useNavigate(),
    chatSettings = chat?.users?.find((x) => x.user._id === currentUser._id);

  function getHeaderObject() {
    if (chat.group)
      return {
        name: chat.name
      };

    return chat.users?.find((x) => currentUser._id !== (x.user._id || x.user)).user;
  }

  return (
    <Col noFlex pad="0 16px" wid="100%" ht="100%">
      <Row wid="100%" center between>
        <Row center>
          {isMobile && (
            <Clickable marg="0 16px 0 0" onClick={() => removeSelection(null)}>
              <Icon type="arrowLeft" dimensions={18} />
            </Clickable>
          )}
          {chat.group ? (
            <GroupAvatar chatName={getHeaderObject()?.name} small />
          ) : (
            <Clickable onClick={() => navigate(`/profile/${getHeaderObject().username}`)}>
              <Avatar showVerified small user={getHeaderObject()} />
            </Clickable>
          )}

          <Col marg="0 0 0 10px" center>
            <Clickable onClick={() => navigate(`/profile/${getHeaderObject().username}`)}>
              <Row center start>
                {chatSettings?.favorite && (
                  <Icon type="starFilled" dimensions={20} col={theme.ORANGE} marg="0 6px 0 0" />
                )}

                <Text h4>{getHeaderObject()?.name}</Text>
              </Row>
            </Clickable>

            {/*
              <Text b2 med col={theme.GREY_60} marg='2px 0 0'>
                Last seen just now
              </Text>
            */}
          </Col>
        </Row>

        <Clickable onClick={() => setShowMenu(!showMenu)}>
          <Icon type="menu" dimensions={16} col={theme.GREY_50} />
        </Clickable>
      </Row>

      <Menu visible={showMenu} setVisible={setShowMenu} chat={chat} user={currentUser} />
    </Col>
  );
};

export default ChatHeader;
